module.exports = __webpack_public_path__ + "img/4w-w.4fb9923f.png";